// TODO: shared/auth/fetch/sesionApi.ts でしか使われていないので、OpenAPIにスキーマ定義され次第
// TODO: こちらの削除と、axoisのuninstallを検討
import { keysToSnakeCase } from "@/shared/lib/case";
import axios, { type AxiosInstance } from "axios";

axios.defaults.baseURL = import.meta.env.VITE_API_URL;
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    config.headers["Content-Type"] = "multipart/form-data";
  } else if (config.data) {
    config.data = keysToSnakeCase(config.data);
    config.headers["Content-Type"] = "application/json";
  }
  return config;
});

export const baseApi: AxiosInstance = axios;
